import Footer from "components/shared/Footer/Footer";
import Sidebar from "components/shared/Sidebar/Sidebar";
import TopHeader from "components/shared/TopHeader/TopHeader";
import { useState } from "react";
import { Outlet } from "react-router-dom";

export default function BasicMainLayout() {
    const [toggle, setToggle] = useState(false);

    return (
        <div className={`${toggle ? "" : "toggled"} page-wrapper doctris-theme`}>
            <Sidebar menuClass={"sidebar-wrapper"} />

            <main className="page-content bg-light">
                <TopHeader toggle={toggle} setToggle={setToggle} />

                <Outlet />

                <Footer />
            </main>
        </div>
    )
}